import { render, staticRenderFns } from "./pintuan.vue?vue&type=template&id=fef8204e&scoped=true&"
import script from "./pintuan.vue?vue&type=script&lang=ts&"
export * from "./pintuan.vue?vue&type=script&lang=ts&"
import style0 from "./pintuan.vue?vue&type=style&index=0&id=fef8204e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef8204e",
  null
  
)

export default component.exports